/**
 * Module-level ref registry for the live-streaming answer DOM node.
 *
 * StreamingDraft registers its answer-body element on mount and clears on unmount.
 * useBotStreamSubscription appends characters directly into this node without
 * touching React state, so repaint cost is minimal and we can animate at 60–120fps
 * even when the backend emits large delta batches at ~2/sec.
 */
interface StreamingRefRegistry {
  el: HTMLElement | null;
  scrollHost: HTMLElement | null;
  onDrain?: () => void;
}

export const streamingAnswerRef: StreamingRefRegistry = {
  el: null,
  scrollHost: null,
};
